<template>
  <div
    class="z-30 absolute inset-0 bg-indigo-600 bg-opacity-85 rounded-lg"
    v-if="evaluationInProgress"
  >
    <div class="md:-my-2 py-0 md:py-20 sm:px-6 lg:px-24 h-full md:h-auto">
      <div
        class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table h-full"
      >
        <div class="m-5 md:m-15 2xl:m-20 mt-10 md:mt-20 2xl:mt-32 w-auto h-auto">
          <h3 class="mb-5 md:mb-10 2xl:mb-15">
            {{ infosPage.libelle_template }}
          </h3>

          <div class="text-lg text-gray-600 text-center mb-5 md:mb-10 2xl:mb-15">
            <p>Le modèle de page « {{ infosPage.libelle_template }} » n’est pas modifiable ou désactivable,</p>
            <p>car il existe au minimum une évaluation en cours.</p>
            <p>Veuillez clôturer les évaluations pour modifier cette page.</p>
          </div>

          <span
            class="flex space-x-3 justify-center mb-5 md:mb-10 2xl:mb-15"
          >
            <action-button
              v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_APERCU)"
              class="h-full"
              border-color="border-indigo-600"
              text-color="text-indigo-600"
              bg-color="bg-white"
              bg-color-square="bg-white"
              icon-color="text-pink-600"
              libelle="Visualiser le modèle"
              icon="eye"
              @clickAction="$emit('showPreview')"
            />

            <action-button
              v-if="$can(constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE)"
              class="h-full"
              border-color="border-transparent"
              text-color="text-gray-900"
              bg-color="bg-teal-300"
              bg-color-square="bg-teal-100"
              icon-color="text-teal-600"
              libelle="Attribuer"
              icon="people"
              @clickAction="assignTemplate()"
            />
          </span>

          <div class="flex justify-center">
            <illustration
              name="notAllowed"
              class="inline-block"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from '../../components/ActionButton';
import Illustration from '../../components/Illustration';
import { mapGetters } from 'vuex';
import Constants from './../../constants';

export default {
  name: 'EvalInProgress',
  components: { ActionButton, Illustration },
  emits: ['showPreview', 'massAssignation'],
  props: {
    evaluationInProgress: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      constants: Constants,
    };
  },
  methods: {
    assignTemplate() {
      if(this.$can(Constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE)){
        this.$emit('massAssignation');
      }
    }
  },
  computed: {
    ...mapGetters({
      infosPage: 'template/infosPage',
    }),
  },
};
</script>